import { FaUnity } from 'react-icons/fa'

import type { ISelectOption } from '~/types/option'

import { TEMPLATE_STATUS_LABEL_MAPPING, TEMPLATE_TYPE_LABEL_MAPPING } from '.'
import LandscapeSVG from '~/assets/landscape.svg'
import PortraitSVG from '~/assets/portrait.svg'
import { TEMPLATE_STATUS, TEMPLATE_TYPE } from '~/types/template'

export const orientationOptions: ISelectOption[] = [
  { label: 'All', value: '' },
  {
    image: (
      <>
        <img src={PortraitSVG} />
        <img src={LandscapeSVG} />
      </>
    ),
    label: 'Both',
    value: 'both',
  },
  { image: <img src={PortraitSVG} />, label: 'Portrait', value: 'portrait' },
  { image: <img src={LandscapeSVG} />, label: 'Landscape', value: 'landscape' },
]

export const statusOptions = [
  { label: 'All', value: '' },
  { label: TEMPLATE_STATUS_LABEL_MAPPING[TEMPLATE_STATUS.DRAFT], value: TEMPLATE_STATUS.DRAFT },
  { label: TEMPLATE_STATUS_LABEL_MAPPING[TEMPLATE_STATUS.READY], value: TEMPLATE_STATUS.READY },
  { label: TEMPLATE_STATUS_LABEL_MAPPING[TEMPLATE_STATUS.ARCHIVED], value: TEMPLATE_STATUS.ARCHIVED },
]

export const typeOptions = [
  { label: 'All', value: '' },
  {
    label: TEMPLATE_TYPE_LABEL_MAPPING[TEMPLATE_TYPE.HORIZONTAL_MULTI_PAGE_CONTAINER],
    value: TEMPLATE_TYPE.HORIZONTAL_MULTI_PAGE_CONTAINER,
  },
  {
    label: TEMPLATE_TYPE_LABEL_MAPPING[TEMPLATE_TYPE.SINGLE_PAGE_CONTAINER],
    value: TEMPLATE_TYPE.SINGLE_PAGE_CONTAINER,
  },
]

export const isUnityOptions = [
  { label: 'Both', value: '' },
  { image: <FaUnity />, label: 'Yes', value: true },
  { label: 'No', value: false },
]

export const DEFAULT_IAP_PRICE_COUNTRY = 'US'
